import { Tag } from '@cian/components';
import * as React from 'react';

import { EWindowsType } from '../../../../json_query';
import { IWindowsTypeTag } from '../../../state/tags/definitions/windows';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IWindowsTypeTagItemProps {
  tag: IWindowsTypeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const windowsTypeMap = {
  [EWindowsType.Courtyard]: 'во двор',
  [EWindowsType.Street]: 'на улицу',
};

export const WindowsTypeTagItem = ({ tag, onDeleteClick, withNewTag }: IWindowsTypeTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  if (tag.value === EWindowsType.Any) {
    return null;
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Окна {windowsTypeMap[tag.value]}
    </TagComponent>
  );
};
